import { ServiceForm } from "@/components/service/service-form";

export function NewServicePage() {
  return <ServiceForm mode="create" />;
}
